import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function deleteNotice(data) {
    Bus.$emit("deleteNotice", data);
  }

  function setUp(data, type) {
    Bus.$emit("setUp", { id: data, status: type });
  }

  function setDown(data, type) {
    Bus.$emit("setUp", { id: data, status: type });
  }

  function editNotice(data) {
    router.push({
      path: "/onlineClass/classNotice/addNotice",
      query: {
        noticeDetail: data
      }
    });
  }

  const Deal = ({ props: { vo } }) => {
    const user = vo.row;
    let dealConf = [
      ["icon-edit", "修改", () => editNotice(user), "class:notice:update"],
      [
        "icon-delete",
        "删除",
        () => deleteNotice(user.uuid),
        "class:notice:delete"
      ]
    ];
    if (user.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => setDown(user.uuid, 0),
        "class:notice:status"
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => setUp(user.uuid, 1),
        "class:notice:status"
      ]);
    }

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "公告标题",
      prop: "title",
      minWidth: "130"
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "80"
    },
    {
      label: "创建者",
      prop: "createUserName",
      minWidth: "100"
    },
    {
      label: "最后更新时间",
      prop: "updateDate",
      minWidth: "150"
    },
    {
      label: "序号",
      prop: "order",
      minWidth: "80"
    },
    {
      label: "操作",
      minWidth: "140",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
